import React from 'react';
export function StickyTopBar() {
  return <div className="sticky top-0 z-50 w-full bg-darker text-white py-3 px-4 text-center shadow-md" data-id="element-228">
      <p className="text-sm md:text-base font-medium" data-id="element-229">
        <span className="text-primary font-bold" data-id="element-230">🔥 OFERTA ESPECIAL:</span> 50%
        de descuento — ¡Solo por tiempo limitado!
      </p>
    </div>;
}